import {useImportFromFileStore} from '../import-from-file-store'
import {validateFile} from './validate-file'
import {onLoadFile} from './on-load-file'

type Ret = {
  prepareFile: (file?: File) => void
}

export const usePrepareFile = (): Ret => {
  const [state] = useImportFromFileStore()

  const prepareFile = (file?: File): void => {
    state.loading = true
    state.errors = []

    if (!file) {
      return
    }

    const {isValid, errorMessage = ''} = validateFile(file)
    if (!isValid) {
      state.errors = [errorMessage]
      state.canStartImport = false
      state.loading = false
      return
    }

    const reader = new FileReader()
    reader.onload = onLoadFile(state, file)
    reader.readAsText(file, 'utf-8')
  }

  return {prepareFile}
}
